import { ErrorMessage, Field } from 'formik';

import ReactSelectPorts from '../../ReactSelectPorts';
import TextError from '../../TextError';

import '../../../../captains-form/styles/mandatory-check.scss'; // Ensure the styles are imported
import '../../../styles/multi-select.scss';

export default function PortsDropdown(props) {
  const {
    label,
    name,
    onInputChange,
    getSpecificValue,
    onChange,
    hasError = false,
    errorMessage = '',
    required = false,
    ...rest
  } = props;

  return (
    <div className={'form-control multi-select'}>
      {label ? (
        <label className="input__label" htmlFor={name}>
          {label}
          {required ? <span>*</span> : null}
        </label>
      ) : null}
      {props.sublabel ? (
        <span className="sublabel">{props.sublabel}</span>
      ) : null}
      <Field
        name={name}
        id={name}
        onChange={onChange}
        isMulti={true}
        component={ReactSelectPorts}
        onInputChange={onInputChange}
        getSpecificValue={getSpecificValue}
        className={hasError ? 'input-error-border' : ''}
        {...rest}
      />
      {hasError ? <div className="error-dropdown">{errorMessage}</div> : null}
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
}
